/* eslint-disable */
import { axios } from "~/plugins/axios"

const state = {}

const getters = {}

const actions = {
  async getNotifications(ctx, payload) {
    return await axios.post('/api/notifications', payload)
      .then(resp => {
        return resp.data
      })
  },

  async getNotification(ctx, id) {
    return await axios.get(`/api/notifications/${id}`)
      .then(resp => {
        return resp.data
      })
  },

  async getunreadNotificationsCount(ctx) {
    return await axios.get('/api/notifications/count-unread-messages')
      .then(resp => {
        return resp.data
      })
  },

  async markAsRead(ctx, id) {
    return await axios.get(`/api/notifications/${id}/mark-as-read`)
      .then(resp => {
        return resp.data
      })
  },
}


const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}